/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { CommonModule } from "@angular/common";
import {
  APP_INITIALIZER,
  ApplicationModule,
  ErrorHandler,
  InjectionToken,
  NgModule,
  NgZone,
  PLATFORM_ID,
  PlatformRef,
  Provider,
  RendererFactory2,
  createPlatformFactory,
  platformCore,
} from "@angular/core";
// import { ɵBROWSER_SANITIZATION_PROVIDERS as BROWSER_SANITIZATION_PROVIDERS } from '@angular/platform-browser';
import { ON_WEB_WORKER, DEBUG } from "./web_workers/shared/api";
import { ClientMessageBrokerFactory } from "./web_workers/shared/client_message_broker";
import { MessageBus } from "./web_workers/shared/message_bus";
import {
  PostMessageBus,
  PostMessageBusSink,
  PostMessageBusSource,
} from "./web_workers/shared/post_message_bus";
import { RenderStore } from "./web_workers/shared/render_store";
import { ServiceMessageBrokerFactory } from "./web_workers/shared/service_message_broker";
import { ServiceMessageBrokerRegistry } from "./web_workers/shared/service_message_broker_registry";
import { ServiceMessageBrokerRegistryReplica } from "./web_workers/shared/service_message_broker_registry_replica";
import { NoOpRootRenderer } from "./web_workers/shared/renderer";
import { WorkerDomAdapter } from "./web_workers/worker/worker_adapter";
import { WebWorkerRendererFactory2 } from "./web_workers/worker/renderer";

/**
 * @experimental
 */
export const platformWorkerApp = createPlatformFactory(platformCore, "workerApp", [
  { provide: PLATFORM_ID, useValue: Symbol("PLATFORM_WORKER_APP_ID") },
]);

export const WORKER_UID: any = new InjectionToken("Worker Unique Identifier");

export function errorHandler(): ErrorHandler {
  return new ErrorHandler();
}

// TODO(jteplitz602) remove this and compile with lib.webworker.d.ts (#3492)
const _postMessage = {
  postMessage: (message: any, transferrables?: [ArrayBuffer]) => {
    (<any>postMessage)(message, transferrables);
  },
};

export function createMessageBus(zone: NgZone): MessageBus {
  const sink = new PostMessageBusSink(_postMessage);
  const source = new PostMessageBusSource();
  const bus = new PostMessageBus(sink, source);
  bus.attachToZone(zone);
  return bus;
}

export function setupWebWorker(): void {
  WorkerDomAdapter.makeCurrent();
}

export function createWorkerUid(): string {
  const time: string = new Date().getTime() + "";
  let id: string = name + time; // + stringify(iteration);

  return id;
}

/**
 * The ng module for the worker app side.
 *
 * @experimental
 */
@NgModule({
  providers: [
    // BROWSER_SANITIZATION_PROVIDERS,
    ClientMessageBrokerFactory,
    ServiceMessageBrokerFactory,
    // { provide: ServiceMessageBrokerRegistryReplica},
    {
      provide: ServiceMessageBrokerRegistry,
      useClass: ServiceMessageBrokerRegistryReplica,
    },
    // NoOpRootRenderer, { provide: RootRenderer2, useExisting: NoOpRootRenderer },
    { provide: ON_WEB_WORKER, useValue: true },
    RenderStore,
    WebWorkerRendererFactory2,
    { provide: RendererFactory2, useExisting: WebWorkerRendererFactory2 },
    { provide: ErrorHandler, useFactory: errorHandler, deps: [] },
    { provide: MessageBus, useFactory: createMessageBus, deps: [NgZone] },
    { provide: APP_INITIALIZER, useValue: setupWebWorker, multi: true },
    { provide: DEBUG, useValue: true },
  ],
  exports: [CommonModule, ApplicationModule],
})
export class WorkerAppModule {}
